import * as React from 'react';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import AlertsContext from '../AlertsContext';

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

export default function Alerts() {
  const { alert, setAlert } = React.useContext(AlertsContext);

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setAlert("");
  };

  return alert && (
    <Stack spacing={2} sx={{ width: '100%' }}>
      {/* Do not hide on error */}
      <Snackbar open={!!alert} autoHideDuration={alert?.type !== "error" ? 5000 : null} onClose={handleClose}>
        <Alert onClose={handleClose} severity={alert?.type ?? "success"} sx={{ width: '100%' }}>
          {alert?.message ?? alert}
        </Alert>
      </Snackbar>
    </Stack>
  );
}
